import React, { useState } from 'react';
import s from './Pruchases/Purchases.module.scss';
import { ReactComponent as IconUploadBg } from 'images/new-icons/image-loader.svg';
import Button from 'components/shared/Button';
import clsx from 'clsx';
import ProfileMenuHeader from './ProfileMenuHeader';
import supabase from 'sdk/api';

const UploadImageItems = [
  { id: 'defect', name: 'Photo of defect (Mandatory)' },
  { id: 'extra1', name: 'Additional photo' },
  { id: 'extra2', name: 'Additional photo' },
  { id: 'extra3', name: 'Additional photo' },
];

const LoadingSpinner = () => (
  <div className={s.spinner}>
    <div className={s.doubleBounce1}></div>
    <div className={s.doubleBounce2}></div>
  </div>
);

const UploadImageBooking = ({ mediaUrls, setMediaUrls, onNext, onBack }) => {
  const [isMediaLoading, setIsMediaLoading] = useState<Record<string, boolean>>({});

  const uploadToSupabase = async (file: File) => {
    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}-${Date.now()}.${fileExt}`;
    const filePath = fileName; // Убрал refunds/ отсюда

    try {
      const { data, error } = await supabase.storage
        .from('refunds')
        .upload(filePath, file);

      if (error) {
        console.error('Error uploading to Supabase:', error);
        return null;
      }

      const { data: publicUrlData } = supabase.storage
        .from('refunds')
        .getPublicUrl(filePath);

      return publicUrlData.publicUrl;
    } catch (error) {
      console.error('Error in upload process:', error);
      return null;
    }
  };

  const onBgUpload = async (e, itemId) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsMediaLoading(prev => ({ ...prev, [itemId]: true }));

    try {
      const url = await uploadToSupabase(file);
      if (url) {
        setMediaUrls(prev => ({ ...prev, [itemId]: url }));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsMediaLoading(prev => ({ ...prev, [itemId]: false }));
    }
  };

  const renderUploadContent = itemId => {
    if (isMediaLoading[itemId]) {
      return <LoadingSpinner />;
    }

    if (mediaUrls[itemId]) {
      if (mediaUrls[itemId].endsWith('.mp4') || mediaUrls[itemId].includes('video')) {
        return (
          <video controls playsInline muted className={s.uploadedMedia}>
            <source src={mediaUrls[itemId]} type="video/mp4" />
          </video>
        );
      }
      return <img src={mediaUrls[itemId]} alt="" className={s.uploadedMedia} />;
    }

    return <IconUploadBg />;
  };

  return (
    <div className={clsx(s.upload_image, s.upload_image_booking)}>
      <ProfileMenuHeader text="" onClose={onBack} />
      <div>
        <div className={s.upload_image_title}>Upload photo</div>
        <div className={s.upload_image_description}>
          <div className={s.upload_image_description_title}>Upload photo or video</div>
          <div className={s.upload_image_description_text}>
            Please upload clear photos of the defect to help us process your
            refund faster.
          </div>
        </div>
        {UploadImageItems.map(item => (
          <div key={item.id} className={s.upload_image_upload}>
            <form className={s.bgUploadLabel}>
              <label htmlFor={`upload_${item.id}`}>
                <input
                  type="file"
                  name="file"
                  id={`upload_${item.id}`}
                  className={s.bgUploadInput}
                  onChange={e => onBgUpload(e, item.id)}
                  accept={'image/*, video/*'}
                />
                {renderUploadContent(item.id)}
              </label>
            </form>
            <div className={s.upload_image_upload_text}>{item.name}</div>
          </div>
        ))}
      </div>
      <Button
        wide
        darkGreen
        style={{ marginTop: 'auto' }}
        disabled={Object.keys(mediaUrls).length < 1}
        onClick={onNext}
      >
        Continue
      </Button>
    </div>
  );
};

export default UploadImageBooking;

